module.exports = require('./bundle-url').getBundleURL() + "plocklepeopleplaying.8e7e8e7d.webm"